/** @format */

// 本地缓存，用于跨页面缓存，缓存内容包括侧栏状态，产品列表，平台应用列表，企业信息
const localstorageKey = 'local-cache';

function getLocalCache() {
  let res;
  try {
    res = JSON.parse(window.localStorage.getItem(localstorageKey));
  } catch (error) {
    console.error('json parse error');
  }
  return res || {};
}

function setLocalCache(cache) {
  window.localStorage.setItem(localstorageKey, JSON.stringify(cache));
}

function get(key) {
  const cache = getLocalCache() || {};
  return cache[key];
}

function set(key, value) {
  const cache = getLocalCache() || {};
  cache[key] = value;
  setLocalCache(cache);
}

function del(key) {
  const cache = getLocalCache();
  delete cache[key];
  setLocalCache(cache);
}

function clear() {
  setLocalCache('');
}

export default {
  get,
  set,
  del,
  clear
};
